import Homepage from "./pages/Homepage";
import Login from "./pages/Login";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Details from "./pages/Details";
import UserLogin from "./pages/UserLogin";
import Comedy from "./pages/Comedy";
import Horror from "./pages/Horror";
import Action from "./pages/Action";
import Netflix from "./pages/Netflix";
import Animation from "./pages/Animation";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "./firebase";
import Profile from "./pages/Profile";

function App() {
  const [user] = useAuthState(auth);

  return (
    <BrowserRouter>
      {user ? (
        <div>
          <Switch>
            <Route path="/comedy" component={Comedy} />
            <Route path="/horror" component={Horror} />
            <Route path="/action" component={Action} />
            <Route path="/animation" component={Animation} />
            <Route path="/netflix" component={Netflix} />
            <Route path="/details" component={Details} />
            <Route path="/profile" component={Profile} />
            <Route path="/" component={Homepage} />
          </Switch>
        </div>
      ) : (
        <div>
          <Switch>
            <Route path="/login" component={UserLogin} />
            <Route path="/" component={Login} />
          </Switch>
        </div>
      )}
    </BrowserRouter>
  );
}

export default App;
